export default __webpack_public_path__ + "media/129737d2176f7db8890f8e3b26cf0ab1a04791aa31fa8be9679c798163d4ff18.svg";